module.exports = __webpack_public_path__ + "static/media/the-dutch-cover.215eed0e.jpg";